<script>
    import CloseMenu from "./inc/CloseMenu.svelte";
    import { push, link, location } from 'svelte-spa-router';
    import { isOpenMenu, initialMenuTransitionState } from '../../store.js';
    import { j } from '../../helpers.js';
    let visibility;

    const toggleMenu = () => {
        isOpenMenu.update(menuState => menuState = !menuState);
        initialMenuTransitionState.update(value => value = false);
    }
    
    document.addEventListener('keydown', (e) => { 
        if (e.key == "Escape" || e.key == "Esc" ) {
            closeMenu(); 
        }
    });
    function closeMenu() {
        if ($isOpenMenu === false) {
            return
        }
        toggleMenu();
    }
    function jumpTo(e) {
        let scrollToElem;
        scrollToElem = e.target.getAttribute("href");

        if ($location === '/contact') {
            push('/');
            closeMenu();
            setTimeout(() => {
                j(scrollToElem);
            }, 3);
        } else {
            closeMenu();
            j(scrollToElem);
        }
    }
    $: {
        visibility = $isOpenMenu;
    }
</script>

<section class="mobile_menu_wrapper">

    <nav class="mobile_menu_cnt" class:initial="{ $initialMenuTransitionState }" class:active="{ visibility }" class:hidden="{ !visibility }" on:click|self={ closeMenu }>
        <div class="mobile_menu_cnt__inner" class:initial="{ $initialMenuTransitionState }" class:active="{ visibility }" class:hidden="{ !visibility }">
            <div class="menu_content">
                <div class="menu_content__logo">
                    <a use:link href="/" title="Home" on:click={ closeMenu }>
                        <svg version="1.1" class="logo" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px"
                            y="0px" viewBox="0 0 1059 123" style="enable-background:new 0 0 1059 123;" xml:space="preserve">
                            <style type="text/css">
                                .logo_path{stroke-width:4;stroke-miterlimit:10;}
                            </style>
                            <g>
                                <path class="logo_path" d="M70.3,9.9c3.3,2,7.6,5,10.4,7.8s5.1,5.9,7.1,9.2c2,3.4,3.5,7,4.6,10.8c1.1,3.9,1.6,7.8,1.6,12.1c0,6.2-1.2,12.1-3.6,17.7
                                    c-2.3,5.5-5.6,10.4-9.7,14.4s-8.9,7.4-14.4,9.7s-11.4,3.6-17.7,3.6H25.9v22.7H3.2V4.3h45.4c4.1,0,8.2,0.5,12.1,1.6
                                    c3.8,1.2,7.4,2.7,10.8,4.7 M57.4,28.9c-2.7-1.2-5.7-1.8-8.8-1.8H25.9v45.4h22.7c3.2,0,6-0.6,8.8-1.8c2.7-1.2,5.1-2.8,7.2-4.9
                                    c2.1-2.1,3.7-4.5,4.9-7.2s1.8-5.7,1.8-8.8c0-3.2-0.6-6-1.8-8.8c-1.2-2.8-2.8-5.2-4.9-7.2C62.5,31.8,60.1,30,57.4,28.9"/>
                                <path class="logo_path" d="M130.3,10.9c4.3-2.5,9-4.5,14.1-5.9c5-1.4,10.2-2.1,15.6-2.1s10.5,0.7,15.6,2.1c5,1.4,9.7,3.3,14.1,5.9
                                    c4.3,2.5,8.3,5.6,11.9,9.2c3.6,3.6,6.7,7.6,9.2,11.9s4.5,9,5.9,14.1c1.4,5,2.1,10.2,2.1,15.6s-0.7,10.5-2.1,15.6
                                    c-1.4,5-3.3,9.6-5.9,14.1c-2.5,4.4-5.6,8.3-9.2,11.9c-3.6,3.6-7.6,6.7-11.9,9.2s-9,4.5-14.1,5.9c-5,1.4-10.2,2.1-15.6,2.1
                                    s-10.5-0.7-15.6-2.1c-5-1.4-9.6-3.3-14.1-5.9c-4.3-2.5-8.3-5.7-11.9-9.2c-3.6-3.6-6.7-7.6-9.2-11.9s-4.5-9-5.9-14.1
                                    c-1.4-5-2.1-10.2-2.1-15.6s0.7-10.5,2.1-15.6c1.4-5,3.3-9.7,5.9-14.1c2.5-4.3,5.7-8.3,9.2-11.9C122,16.5,125.9,13.4,130.3,10.9
                                    M145.8,28.3c-4.4,1.9-8.2,4.5-11.4,7.7s-5.9,7.1-7.7,11.4c-1.9,4.4-2.9,9.1-2.9,14.1s1,9.6,2.9,14c1.9,4.3,4.5,8.2,7.7,11.4
                                    c3.2,3.2,7.1,5.9,11.4,7.7c4.4,1.9,9.1,2.9,14.1,2.9s9.6-1,14.1-2.9c4.4-1.9,8.2-4.5,11.4-7.7s5.9-7.1,7.7-11.4
                                    c1.9-4.3,2.9-9,2.9-14s-1-9.6-2.9-14.1c-1.9-4.4-4.5-8.2-7.7-11.4s-7.1-5.9-11.4-7.7c-4.4-1.9-9.1-2.9-14.1-2.9
                                    C154.9,25.5,150.1,26.4,145.8,28.3"/>
                                <path class="logo_path" d="M254.8,27l-34.1,0.1V4.4h90.8v22.7h-34v90.8h-22.6L254.4,25"/>
                                <path class="logo_path" d="M346.6,8c5.5-2.3,11.4-3.6,17.7-3.6S376.5,5.6,382,8c5.5,2.3,10.4,5.6,14.4,9.7s7.4,8.9,9.7,14.4s3.6,11.4,3.6,17.7v68.1
                                    H387V95.2h-45.4v22.7H319V49.8c0-6.3,1.2-12.2,3.6-17.7c2.3-5.5,5.6-10.4,9.7-14.4C336.3,13.5,341.1,10.3,346.6,8 M355.5,28.9
                                    c-2.8,1.2-5.2,2.8-7.2,4.9s-3.7,4.5-4.9,7.2s-1.8,5.7-1.8,8.8v22.7H387V49.8c0-3.2-0.6-6-1.8-8.8s-2.8-5.2-4.9-7.2
                                    s-4.5-3.7-7.2-4.9s-5.7-1.8-8.8-1.8C361.1,27,358.2,27.7,355.5,28.9"/>
                                <path class="logo_path" d="M451.1,27l-34.2,0.1V4.4h90.8v22.7h-34.1v90.8H451l-0.4-92.4"/>
                                <path class="logo_path" d="M512.1,46c1.4-5,3.3-9.7,5.9-14.1c2.5-4.3,5.7-8.3,9.2-11.9c3.6-3.6,7.6-6.7,11.9-9.2c4.3-2.5,9-4.5,14.1-5.9
                                    c5-1.4,10.2-2.1,15.6-2.1s10.5,0.7,15.6,2.1c5,1.4,9.7,3.3,14.1,5.9c4.3,2.5,8.3,5.6,11.9,9.2s6.7,7.6,9.2,11.9s4.5,9,5.9,14.1
                                    c1.4,5,2.1,10.2,2.1,15.6s-0.7,10.5-2.1,15.6c-1.4,5-3.3,9.6-5.9,14.1s-5.6,8.3-9.2,11.9s-7.6,6.7-11.9,9.2
                                    c-4.3,2.5-9,4.5-14.1,5.9c-5,1.4-10.2,2.1-15.6,2.1s-10.5-0.7-15.6-2.1s-9.6-3.3-14.1-5.9c-4.3-2.5-8.3-5.7-11.9-9.2
                                    c-3.6-3.6-6.7-7.6-9.2-11.9s-4.5-9-5.9-14.1c-1.4-5-2.1-10.2-2.1-15.6C510.1,56.1,510.7,51,512.1,46 M535.5,47.5
                                    c-1.9,4.4-2.9,9.1-2.9,14.1s1,9.6,2.9,14c1.9,4.3,4.5,8.2,7.7,11.4c3.2,3.2,7.1,5.9,11.4,7.7c4.4,1.9,9.1,2.9,14.1,2.9
                                    s9.6-1,14.1-2.9c4.4-1.9,8.2-4.5,11.4-7.7s5.9-7.1,7.7-11.4s2.9-9,2.9-14s-1-9.6-2.9-14.1c-1.9-4.4-4.5-8.2-7.7-11.4
                                    s-7.1-5.9-11.4-7.7c-4.4-1.9-9.1-2.9-14.1-2.9s-9.7,1-14.1,2.9c-4.4,1.9-8.2,4.5-11.4,7.7S537.3,43.2,535.5,47.5"/>
                                <path class="logo_path sites_path" d="M635.6,38.4c0-4.7,0.9-9.1,2.7-13.2s4.2-7.7,7.3-10.8s6.7-5.5,10.8-7.3s8.6-2.7,13.2-2.7h52.1v22.7h-52.1
                                    c-1.6,0-3.1,0.3-4.4,0.9c-1.4,0.5-2.6,1.4-3.6,2.4c-1,1.1-1.8,2.3-2.4,3.6c-0.5,1.4-0.9,2.9-0.9,4.4s0.3,3.1,0.9,4.5
                                    c0.5,1.4,1.4,2.6,2.4,3.6c1.1,1,2.3,1.8,3.6,2.4c1.4,0.5,2.9,0.9,4.4,0.9h22.7c4.7,0,9.1,0.9,13.2,2.6c4.1,1.8,7.7,4.2,10.8,7.3
                                    s5.5,6.7,7.3,10.8s2.6,8.6,2.6,13.2s-0.9,9.1-2.6,13.2c-1.8,4.1-4.2,7.7-7.3,10.8s-6.7,5.5-10.8,7.3s-8.6,2.7-13.2,2.7h-50.4V95
                                    h50.4c1.6,0,3.1-0.3,4.4-0.9c1.4-0.5,2.6-1.4,3.6-2.4s1.8-2.3,2.4-3.6c0.5-1.4,0.9-2.9,0.9-4.4s-0.3-3.1-0.9-4.4
                                    c-0.5-1.4-1.4-2.6-2.4-3.6c-1.1-1-2.3-1.8-3.6-2.4c-1.4-0.5-2.9-0.9-4.4-0.9h-22.7c-4.7,0-9.1-0.9-13.2-2.7
                                    c-4.1-1.8-7.7-4.2-10.8-7.3c-3.1-3.1-5.5-6.7-7.3-10.8S635.6,43.1,635.6,38.4"/>
                                <path class="logo_path sites_path" d="M764.2,4.4l-0.1,113.5h-22.7V4.3L764.2,4.4"/>
                                <path class="logo_path sites_path" d="M866.9,4.5v22.6h-34.1v90.8h-22.6V27.1h-34.1V4.4L866.9,4.5"/>
                                <path class="logo_path sites_path" d="M956.6,4.4l0.2,22.7h-55.1v22.7H939v22.7h-37.3v22.6h55.1v22.7H879V4.3L956.6,4.4"/>
                                <path class="logo_path sites_path" d="M967.4,25.2c1.8-4.1,4.2-7.7,7.3-10.8s6.7-5.5,10.8-7.3s8.6-2.7,13.2-2.7h52.1v22.7h-52.1c-1.6,0-3.1,0.3-4.4,0.9
                                    c-1.4,0.5-2.6,1.4-3.6,2.4c-1,1.1-1.8,2.3-2.4,3.6c-0.5,1.4-0.9,2.9-0.9,4.4s0.3,3.1,0.9,4.5c0.5,1.4,1.4,2.6,2.4,3.6
                                    c1.1,1,2.3,1.8,3.6,2.4c1.4,0.5,2.9,0.9,4.4,0.9h22.7c4.7,0,9.1,0.9,13.2,2.6c4.1,1.8,7.7,4.2,10.8,7.3c3.1,3.1,5.5,6.7,7.3,10.8
                                    s2.6,8.6,2.6,13.2s-0.9,9.1-2.6,13.2c-1.8,4.1-4.2,7.7-7.3,10.8s-6.7,5.5-10.8,7.3s-8.6,2.7-13.2,2.7H971V95h50.4
                                    c1.6,0,3.1-0.3,4.4-0.9c1.4-0.5,2.6-1.4,3.6-2.4s1.8-2.3,2.4-3.6c0.5-1.4,0.9-2.9,0.9-4.4s-0.3-3.1-0.9-4.4
                                    c-0.5-1.4-1.4-2.6-2.4-3.6c-1.1-1-2.3-1.8-3.6-2.4c-1.4-0.5-2.9-0.9-4.4-0.9h-22.7c-4.7,0-9.1-0.9-13.2-2.7
                                    c-4.1-1.8-7.7-4.2-10.8-7.3s-5.5-6.7-7.3-10.8s-2.7-8.6-2.7-13.2C964.8,33.7,965.6,29.3,967.4,25.2"/>
                            </g>
                        </svg>
                    </a>
                </div>
                <CloseMenu on:close-menu={ toggleMenu }/>
                
                <div class="menu">
                    <ul class="menu__list">
                        <li><a href="#home" title="Home" on:click={ closeMenu }>Home</a></li>
                        <li><a href="#about" title="About" on:click|preventDefault={ jumpTo }>About</a></li>
                        <li><a href="#portfolio" title="Portfolio" on:click|preventDefault={ jumpTo }>Portfolio</a></li>
                        <li><a use:link href="/contact" title="Contact" on:click={ closeMenu }>Contact</a></li>
                    </ul>
                </div>
            </div>
        </div>
    </nav>

</section> 

<style lang="scss">
    .mobile_menu_wrapper{
        display: block;
        pointer-events: none;
        .menu_content{
            padding: 1.6rem;
            height: 100%;
            min-height: 660px;
            background-position: center bottom;
            background-repeat: no-repeat;
            background-size: contain;
            &__logo{
                display: flex;
                justify-content: center;
                align-items: center;
            }
        }
        .mobile_menu_cnt{
            position: fixed;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            background-color: rgba(0,0,0,0.75);
            z-index: 400;
            opacity: 1;
            transition-property: opacity;
            transition-duration: 0.2s;
            transition-timing-function: linear;
            pointer-events: auto;
            visibility: visible;
            max-height: 100vh;
            -webkit-backdrop-filter: blur(8px);
            backdrop-filter: none;
            &.hidden{
                -webkit-transition-delay: 0.3s;
                -o-transition-delay: 0.3s;
                transition-delay: 0.3s;
                opacity: 0;
                pointer-events: none;
            }
            &__inner{
                z-index: 500;
                position: absolute;
                right: 0;
                top: 0;
                height: 100%;
                width: 400px;
                display: block;
                overflow-y: scroll;
                &.hidden{
                    -webkit-transition: -webkit-transform 0.4s cubic-bezier(0.445, 0.05, 0.55, 0.95);
                    transition: -webkit-transform 0.4s cubic-bezier(0.445, 0.05, 0.55, 0.95);
                    -o-transition: transform 0.4s cubic-bezier(0.445, 0.05, 0.55, 0.95);
                    transition: transform 0.4s cubic-bezier(0.445, 0.05, 0.55, 0.95);
                    transition: transform 0.4s cubic-bezier(0.445, 0.05, 0.55, 0.95), -webkit-transform 0.4s cubic-bezier(0.445, 0.05, 0.55, 0.95);    
                    -webkit-transform: translate3d(100%, 0, 0);
                    transform: translate3d(100%, 0, 0);
                }
                &.active{
                    -webkit-transition: -webkit-transform 0.4s cubic-bezier(0.445, 0.05, 0.55, 0.95);
                    transition: -webkit-transform 0.4s cubic-bezier(0.445, 0.05, 0.55, 0.95);
                    -o-transition: transform 0.4s cubic-bezier(0.445, 0.05, 0.55, 0.95);
                    transition: transform 0.4s cubic-bezier(0.445, 0.05, 0.55, 0.95);
                    transition: transform 0.4s cubic-bezier(0.445, 0.05, 0.55, 0.95), -webkit-transform 0.4s cubic-bezier(0.445, 0.05, 0.55, 0.95);
                    -webkit-transform: translate3d(0, 0, 0);
                    transform: translate3d(0, 0, 0);
                } 
            }
        }
        .initial{
            transition: none !important;
        }
        .menu{
            padding: 0.9rem;
            height: calc(100% - (74px + 1.6rem + 78px + 1.6rem));
            &__list{
                list-style: none;
                padding: 0;
                margin-bottom: 0;
                margin-top: 0;
                list-style: none;
                padding: 0;
                > li{
                    margin-bottom: 1rem;
                }
            }
        }
    }
    @media screen and (max-width: 480px) {
        .mobile_menu_wrapper{
            .mobile_menu_cnt{
                &__inner{
                    width: 100%;
                }
            }
        }
    }
</style>